import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ResaleInterestsTable from "../../components/ResaleInterests/ResaleInterestsTable";

const ResaleInterestsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Resale Interests" />

        {/* Buyer interest requests table */}
        <ResaleInterestsTable />

      </MasterLayout>
    </>
  );
};

export default ResaleInterestsPage;
